import { Link } from "react-router-dom";
import { primerParrafoHtml } from "../utils/texto";

const NewspaperSection = ({ id, title, image, text, color, subtitle }) => {

  const isColorDark = (color) => {
    if (!color) return false;
    const hex = color.replace(/^#/, '');
    if (hex.length < 6) return false;
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
    return luminance < 0.5;
  };

  const textColor = isColorDark(color) ? 'black' : 'white';



  return (
    <Link to={`/noticias/${id}`}>
      <div className="newspaper-section" style={{ backgroundColor: 'transparent' }}>
        <div className="content-image">
          <img src={image} alt="newspaper" className="image" />
        </div>
        <div className="content" style={{ backgroundColor: 'transparent' }}>
          <h1 className="title" style={{ color: 'black' }}>{title}</h1>
          <h2 className="subtitle" style={{ color: 'black', fontSize: '1rem'  }}>Escrito por: <span style={{ color: 'black', fontFamily: 'Petrona', fontSize: '1rem' }}>{subtitle}</span></h2>
          <div dangerouslySetInnerHTML={{
            __html: primerParrafoHtml(text)
          }} className="text" style={{ color: 'black' }}></div>

          <div className="columns-container">
            <div className='button_categorias' style={{ backgroundColor: color, color: textColor, fontFamily: 'Petrona' }}>
              Ver más
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NewspaperSection;